import { UserRole } from '@prisma/client';

export default class RolesUtils {
  static values: UserRole[] = Object.values(UserRole);

  static labels: { [key in UserRole]: string } = {
    [UserRole.ADMIN]: 'Admin',
    [UserRole.CUSTOMER_CARE]: 'Customer Care',
    [UserRole.OWNER]: 'Owner',
    [UserRole.RECEIVER]: 'Receiver',
    [UserRole.CLEANER]: 'Cleaner',
    [UserRole.MAINTAINER]: 'Maintainer',
    [UserRole.CITY_MANAGER]: 'City Manager',
    [UserRole.AGENCY]: 'Agency',
  };

  static sort(roles: UserRole[]): UserRole[] {
    return roles.sort((a, b) => (a < b ? -1 : 1));
  }

  static getLabel = (num: UserRole): string => RolesUtils.labels[num];

  static getLabels(roles: UserRole[]): string[] {
    return this.sort(roles).map(this.getLabel);
  }

  static primaryRoles = [UserRole.ADMIN, UserRole.CUSTOMER_CARE];

  static secondaryRoles = [
    UserRole.OWNER,
    UserRole.RECEIVER,
    UserRole.CLEANER,
    UserRole.MAINTAINER,
    UserRole.CITY_MANAGER,
  ];
}
